module.exports = __webpack_public_path__ + "img/empty_state_image.a1494515.svg";